import React, { Component } from 'react'
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select'
import DatePicker from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import ls from 'local-storage'

class WorkPropose extends Component {
    constructor(props){
        super(props);   
        this.state = {
          errors: {},
          officelist: [], 
          buttonname:'Add',
          schemelist: [],
          finyearlist: [],
          workcategorylist: [],
          worktypemasterlist: [],
          etpmasterlist: [],
          accountheadlist: [],
          workdetails:{}
        }  
        this.handleChange = this.handleChange.bind(this);  
        this.selecthandleChange = this.selecthandleChange.bind(this); 
        this.selectmultihandleChange = this.selectmultihandleChange.bind(this);        
      }    
      componentDidMount() {  
        document.title = "Works Propose Add/Edit" 
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;       
        
        if(this.props.match.params.id){
          this.setState({buttonname:'Update'});
          Axios.get(`${process.env.REACT_APP_API_URL}works/workdetails/workhead/`+this.props.match.params.id)
        .then(result=>{
          if(result.status === 200){
            this.setState({workdetails:result.data});  
          }      
        });  
      }    

      Axios.get(`${process.env.REACT_APP_API_URL}master/getdivision`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.officecode,
              "label" : d.officesname          
            }))    
            this.setState({officelist: options})             
        }); 
        Axios.get(`${process.env.REACT_APP_API_URL}master/getscheme`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.schemeid,
              "label" : d.schemename          
            }))    
            this.setState({schemelist: options})             
        });   
        Axios.get(`${process.env.REACT_APP_API_URL}master/getfinyear`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.finacial_year,
              "label" : d.finacial_sort          
            }))    
            this.setState({finyearlist: options})             
        });    
        Axios.get(`${process.env.REACT_APP_API_URL}master/workcategory`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.worktypecode,
              "label" : d.worktypename          
            }))    
            this.setState({workcategorylist: options})             
        });
        Axios.get(`${process.env.REACT_APP_API_URL}master/worktypemaster`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.sno,
              "label" : d.description          
            }))    
            this.setState({worktypemasterlist: options})             
        });
        Axios.get(`${process.env.REACT_APP_API_URL}master/getetpmaster`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.etp_par,
              "label" : d.etp_par          
            }))    
            this.setState({etpmasterlist: options})            
        });
        Axios.get(`${process.env.REACT_APP_API_URL}master/accounthead`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.head_id,
              "label" : d.head_cd_nm          
            }))    
            this.setState({accountheadlist: options})            
        });                                              
      } 
      handleValidation(){
        let workdetails = this.state.workdetails;        
        let errors = {};
        let formIsValid = true;
        
        //Work Name
        if(!workdetails["workname"]){
          formIsValid = false;
          errors["workname"] = "Work Name Cannot be empty";
        }
        
        if(typeof workdetails["workname"] !== "undefined"){
          if(!workdetails["workname"].match(/^[a-zA-Z0-9_ .-]+$/)){
            formIsValid = false;
            errors["workname"] = "Only letters";
          }      	
        } 
        //Controlling Office
        if(!workdetails["control_office"]){
            formIsValid = false;
            errors["control_office"] = "Please Select Controlling Office";
          }

          if(typeof workdetails["control_office"] !== "undefined"){
            if(typeof workdetails["control_office"] !== "number"){
              formIsValid = false;
              errors["control_office"] = "Only Number";
            }      	
          }
        //Scheme
        if(!workdetails["schemeid"]){
          formIsValid = false;
          errors["schemeid"] = "Please Select Scheme";
        }    
        if(typeof workdetails["schemeid"] !== "undefined"){
          if(typeof workdetails["schemeid"] !== "number"){
            formIsValid = false;
            errors["schemeid"] = "Only Number";
          }      	
        } 
        //Starting FY
        if(!workdetails["startfinyr"]){
          formIsValid = false;
          errors["startfinyr"] = "Please Select Starting FY";
        }    
        if(typeof workdetails["startfinyr"] !== "undefined"){
          if(typeof workdetails["startfinyr"] !== "number"){
            formIsValid = false;
            errors["startfinyr"] = "Only Number";
          }      	
        }     
        
        //Work Category
        if(!workdetails["roadbuildbridge"]){
          formIsValid = false;
          errors["roadbuildbridge"] = "Please Select Work Category";
        }    
        if(typeof workdetails["roadbuildbridge"] !== "undefined"){
          if(!workdetails["roadbuildbridge"].match(/^[A-Z]+$/)){
            formIsValid = false;
            errors["roadbuildbridge"] = "Only letters";
          }      	
        }   
        //Work Type
        if(!workdetails["worktype"]){
          formIsValid = false;
          errors["worktype"] = "Please Select Work Type";
        }    
        if(typeof workdetails["worktype"] !== "undefined"){
          if(typeof workdetails["worktype"] !== "number"){
            formIsValid = false;
            errors["worktype"] = "Only Number";
          }      	
        }  
        //Estimated cost(Gross)(Rs)
        if(!workdetails["cost"]){
          formIsValid = false;
          errors["cost"] = "Please Enter Estimated cost(Gross)(Rs)";
        }    
        if(typeof workdetails["cost"] !== "undefined"){
          if(!workdetails["cost"].match(/^[0-9.]+$/)){
            formIsValid = false;
            errors["cost"] = "Only Number";
          }      	
        }                      

        this.setState({errors: errors});
        return formIsValid;
      }
    
      contactSubmit(e){        
        e.preventDefault();
        if(this.handleValidation()){
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const data =  this.state.workdetails;  
          Axios.post(`${process.env.REACT_APP_API_URL}works/workinsert`, data) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Redirect To Work List",
                  icon: "success",
                  buttons: true
                })
                .then((responce) => {
                  if (responce) {
                    this.props.history.push({  
                      pathname: '/worklist'
                    });                   
                  } else {
                    this.props.history.push({  
                      pathname: '/work'
                    }); 
                  }
                });
            }
            else{
              swal("Error", result.msg, "error");               
            } 
          }             
            });
        }else{
          swal("Error", "Plese Entry * Fiels", "error");          
        }    
      }    
      async handleChange(event) {
        let workdetails = this.state.workdetails;
        let errors = this.state.errors;
        workdetails[event.target.name] = event.target.value;  
        errors[event.target.name] = '';       
        this.setState({workdetails,errors});       
      }  
      async selecthandleChange(name,e) {
        console.log(e);
        let workdetails = this.state.workdetails;        
        let errors = this.state.errors;
        workdetails[name] = e.value;   
        errors[name] = '';       
        this.setState({workdetails,errors});      
        
      }       
      async selectmultihandleChange(e) {       
        let workdetails = this.state.workdetails;
        workdetails['account_head'] =  Array.isArray(e) ? e.map(x => x.value) : []; 
        this.setState({workdetails}); 
      }  
      datepickerhandleChange(name,e){
        let workdetails = this.state.workdetails;
        workdetails[name] = e.format('DD-MM-YYYY');
        this.setState({workdetails});
      }           
    render() {  
        return (
                <div className="content-wrapper">
                  <section className="content-header">
                      <h1>
                        {this.state.buttonname} Work Propose
                        <small>it all starts here</small>
                      </h1>
                      <ol className="breadcrumb">
                        <li><i className="fa fa-dashboard"></i> Home</li>
                        <li>Work List</li>
                        <li className="active">{this.state.buttonname} Work</li>
                      </ol>
                  </section>
                  <section className="content">
                      <div className="box">
                        <div className="box-body">
                            <form onSubmit= {this.contactSubmit.bind(this)} >
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Work Name</label>
                                        <textarea className="form-control" name="workname" cols="50" rows="2" onChange={this.handleChange} value={ this.state.workdetails.workname || '' } />
                                        <span className="text-red">{this.state.errors["workname"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Work Name Guj</label>
                                        <textarea className="form-control" name="worknameguj" cols="50" rows="2" id="worknameguj" onChange={this.handleChange} value={ this.state.workdetails.worknameguj || '' } />								
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Controlling Office</label>
                                        <Select 
                                        options={this.state.officelist} 
                                        value={this.state.officelist.filter(({value}) => value === this.state.workdetails.control_office) || ''}                                        
                                        name="control_office" 
                                        onChange={this.selecthandleChange.bind(this,'control_office')} 
                                        />                                      
                                        <span className="text-red">{this.state.errors["control_office"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Scheme</label>	
                                        <Select 
                                        options={this.state.schemelist} 
                                        name="schemeid" 
                                        value={this.state.schemelist.filter(({value}) => value === this.state.workdetails.schemeid) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'schemeid')} 
                                        />
                                        <span className="text-red">{this.state.errors["schemeid"]}</span>					
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Starting FY</label>
                                        <Select 
                                        options={this.state.finyearlist} 
                                        name="startfinyr" 
                                        value={this.state.finyearlist.filter(({value}) => value === this.state.workdetails.startfinyr) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'startfinyr')} 
                                        />
                                        <span className="text-red">{this.state.errors["startfinyr"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Work Category</label>
                                        <Select 
                                        options={this.state.workcategorylist} 
                                        name="roadbuildbridge" 
                                        value={this.state.workcategorylist.filter(({value}) => value === this.state.workdetails.roadbuildbridge) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'roadbuildbridge')} 
                                        />
                                        <span className="text-red">{this.state.errors["roadbuildbridge"]}</span>
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Work Type</label>
                                        <Select 
                                        options={this.state.worktypemasterlist} 
                                        name="worktype" 
                                        value={this.state.worktypemasterlist.filter(({value}) => value === this.state.workdetails.worktype) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'worktype')} 
                                        />
                                        <span className="text-red">{this.state.errors["worktype"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Estimated cost(Gross)(Rs)</label>
                                        <input value={this.state.workdetails.cost || ''} className="form-control" type="text" name="cost"  onChange={this.handleChange} />
                                        <span className="text-red">{this.state.errors["cost"]}</span>
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>ETP Charge(%)</label>
                                        <Select 
                                        options={this.state.etpmasterlist} 
                                        name="centage" 
                                        value={this.state.etpmasterlist.filter(({value}) => value === this.state.workdetails.centage) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'centage')} 
                                        />
                                     </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Account Head</label>
                                        <Select 
                                        options={this.state.accountheadlist} 
                                        name="account_head" 
                                        defaultValue={this.state.accountheadlist.filter(({value}) => value === this.state.workdetails.account_head) || ''} 
                                        isMulti
                                        isClearable
                                        onChange={this.selectmultihandleChange} />      
                                    </div>
                                  </div>
                              </div>
                            
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Droped</label>
                                        <select value={this.state.workdetails.drop || ''} className="form-control select2" name="drop" onChange={this.handleChange}>
                                          <option value="N" >No</option>
                                          <option value="Y" >Yes</option>
                                        </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Drop Date</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'dropdate')}
                                            dateFormat="DD-MM-YYYY" 
                                            selected={this.state.workdetails.dropdate}
                                            value={this.state.workdetails.dropdate || ''} 
                                        />	
                                    </div>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Remark Gujarati</label>
                                        <textarea className="form-control" name="remarkguj" cols="50" rows="2" onChange={this.handleChange} value={this.state.workdetails.remarkguj || ''} /> 
                                    </div>
                                  </div>
                              </div>
                              <div className="box-footer">
                                  <button type="submit" className="btn btn-primary" name="Update">{this.state.buttonname || ''} Work</button>
                              </div>
                            </form>
                        </div>
                      </div>
                  </section>
                </div>           
        )
    }
}
export default WorkPropose